module.exports = __webpack_public_path__ + "img/three3Orange.1a68b9dd.png";